import { cn } from "@/lib/utils";

interface RingPulseProps {
  active: boolean;
  className?: string;
}
const RingPulse: React.FC<RingPulseProps> = ({ active, className }) => {
  if (!active) {
    return null;
  }

  return (
    <div
      className={cn(
        "absolute inset-0 inline-block size-[42px] animate-ping rounded-full border-2 border-primary bg-primary opacity-75",
        className,
      )}
    />
  );
};

export default RingPulse;
